// @flow

import React, { Component } from "react";
import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";
// import createUniqueID from "../../utils/createUniqueID";

import { ReactComponent as DotsLoader } from "../../../assets/images/dots-loader.svg";

type PropsType = {
    className?: string,
    active?: boolean,
    fixed?: boolean,
    absolute?: boolean,
    solid?: boolean,
    inline?: boolean,
    text?: string,
};

const bodySelector = document.querySelector("body");

class LoaderCover extends Component<PropsType> {
    // uniqueId = createUniqueID();

    render(): any {
        const activeClass = this.props.active ? "is-active" : "";
        const fixedClass = this.props.fixed ? "loader__cover--fixed" : "";
        const absoluteClass = this.props.absolute
            ? "loader__cover--absolute"
            : "";
        const solidClass = this.props.solid ? "loader__cover--solid" : "";

        const styleObject = { ...this.props.style };

        if (this.props.height) {
            styleObject.height = this.props.height;
        }

        const loaderMarkup = (
            <div
                className={`loader ${activeClass} ${this.props.className}`}
                style={styleObject}
            >
                <CSSTransition
                    key={1}
                    in={this.props.active}
                    timeout={1000}
                    classNames="fade"
                    mountOnEnter
                    unmountOnExit
                >
                    {!this.props.inline ? (
                        <div
                            key={1}
                            className={`loader__cover ${fixedClass} ${absoluteClass} ${solidClass} ${activeClass} ${
                                this.props.className ? this.props.className : ""
                            }`}
                        >
                            <DotsLoader
                                className="loader__cover__loader loader"
                                fill={this.props.fill}
                            />
                            {this.props.text ? (
                                <div className="loader__cover__text">
                                    {this.props.text}
                                </div>
                            ) : null}
                        </div>
                    ) : (
                        <>
                            <DotsLoader
                                className="loader__cover__loader loader"
                                fill={this.props.fill}
                            />
                        </>
                    )}
                </CSSTransition>

                {this.props.children ? (
                    <div className="loader__content">
                        {this.props.children}{" "}
                    </div>
                ) : null}
            </div>
        );

        if (this.props.fixed && bodySelector) {
            return createPortal(loaderMarkup, bodySelector);
        } else {
            return loaderMarkup;
        }
    }
}

export default LoaderCover;
